import React, {useEffect, useState} from 'react';
import axios from 'axios';
import ImageView from "../../../common/ImageView"
import "../css/PressCenter.css"
import { useParams, useNavigate } from 'react-router-dom';
import Foot from '../../HumanResource/img/Footer.png';
import Header from '../../../common/Header_White_Base'; 
import Gallery_Card from './Gallery_Card.js';
import Search from '../../Common/Component/Search.js';
import Pagination from '../../Common/Component//Pagination.js';
import Text from '../../../common/Text.js';

function Gallery() {
        //Header    
        const [remainingHeight, setRemainingHeight] = useState(0);
        const [Display, setDisplay] = useState('none');

        const handleHover = (height) => {
        setRemainingHeight(height);
        console.log('Received Remaining height:', height);
        setDisplay('block');
        console.log('Received Remaining height:', Display);

        };
        const handleHoverEnd = () => {
        console.log('Hover ended in MainComponent');
        setDisplay('none');
        };


        const [allGalleryLists, setAllGalleryLists] = useState([]);
        const [filteredGalleryLists, setFilteredGalleryLists] = useState([]);
        const [searchTerm, setSearchTerm] = useState("");
        const [searchCategory, setSearchCategory] = useState("all");

        const [page, setPage] = useState(1); //첫페이지를 몇번으로 할건지
        const [limit, setlimit] = useState(12); //한페이지단 보여줄 데이터개수
        const [total, setTotal] = useState(filteredGalleryLists.length); // 선택할 몇개까지 나타낼건지
        const offset = (page -1) * limit; //전체 행개수로 카드분배
        const galleryLists = filteredGalleryLists.slice(offset, offset + limit); //페이지 번호별 카드갯수 나누기
       
        //navigate 
        const navigate = useNavigate();
        const handleCardClick = (seq) => {
            navigate('/DetailItems', {
                state: {
                        title: '포토 갤러리',
                        menukey: 2,
                        cardkey: seq
                },
            });
        };

         //Main Data
         useEffect ( () => {
                getGalleryData();
                console.log('db sucess');
        }, []);

       
       const getGalleryData = async () => {
        axios.get('/api/GalleryMainSelect')
       .then(response => {
            setAllGalleryLists(response.data);
            setFilteredGalleryLists(response.data);
            console.log(response.data);
            setTotal(response.data.length);}
       )
       .catch(error => console.error("DB 가져오기 오류", error));
       console.log('total sucess');

   }
        //검색필터
        const handleSearch = () => {
        let filtered = allGalleryLists;
        //제목+내용
        if (searchCategory === 'all') {
            filtered = allGalleryLists.filter(galleryList =>
                galleryList.Title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                galleryList.Contents.toLowerCase().includes(searchTerm.toLowerCase()) 
            );
        //제목
        } else if (searchCategory === 'title') {
            filtered = allGalleryLists.filter(galleryList =>
                galleryList.Title.toLowerCase().includes(searchTerm.toLowerCase())
            );
        //내용
        } else if (searchCategory === 'content') {
            filtered = allGalleryLists.filter(galleryList =>
                galleryList.Contents.toLowerCase().includes(searchTerm.toLowerCase()) 
            );
        }
        setFilteredGalleryLists(filtered);
    }

    //엔터키로 검색
    const handleSearchEnter = (e) => {
        if(e.key === "Enter") {
            handleSearch();
        }
      }     

     return (
               
        <div  className="wrappera">
        <Text variant='titlename' className='TitleF'>포토 갤러리</Text>
        <div className='gallery-list'>
                {galleryLists.map((galleryList,index) =>{
                    return <div className="gallery-item"  onClick={() => handleCardClick(galleryList.Seq)}>
                    <div className="gallery-imgView">
                        <ImageView fileId={galleryList.FileID} />
                    </div>
                    <div style={{display:"flex", flexDirection:"column"}}>
                    <Text variant='px20' className="GalleryT">{galleryList.Title}</Text>
                    <Text variant='px16w400c66'className="GalleryP">{galleryList.Creator} / {galleryList.CreateDt}</Text>
                    </div>
                    </div> 
                })}
                
        </div>


        {/* 페이지네이션 */}
            {/* <div style={{ display : 'flex', flexDirection: 'column', justifyContent : 'center', alignItems:"center", height :"200px", margin : '0px 0 0 0px'}}>
                {filteredGalleryLists.length >=1 &&
                                <Pagination
                                total = {total}
                                limit = {limit}
                                page={page}
                                setPage={setPage}
                                />
                }

            </div> */}
            {/* 검색 */}
            {/* <div className='search-container'>
                <div className='type-container'>
                    <select className='type' value={searchCategory} onChange={e => setSearchCategory(e.target.value)}>
                        <option value="title"> 제목</option>
                        <option value="content"> 내용</option>
                        <option value="all"> 제목 + 내용</option>
                    </select>
                </div>

                <div className='inputBrd'>
                    <input className='input'
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    onKeyDown={e => handleSearchEnter(e)}>
                    </input>
                </div>
                <button className='btnSearch' onClick={handleSearch}>
                    <Text variant="px18">검색</Text>
                </button>
            </div> */}
        </div>
 
     );
 }
 
 export default Gallery;